import router from './router'
import { getToken } from '@/utils/auth' // get token from cookie
import { getTeacherToken } from '@/utils/authTeacher' // get token from cookie

router.beforeEach(async(to, from, next) => {
  // start progress bar

  // determine whether the user has logged in
  const hasToken = getToken()
  const teacherToken = getTeacherToken()
  if (to.meta.mobile) {
    next()
  } else {
    if (to.meta.requireAuth) {
      if (hasToken) {
        next()
      } else {
        next({ path: '/login' })
      }
    } else if (to.meta.teacherAuth) {
      if (teacherToken) {
        next()
      } else {
        next({ path: '/teacher-login' })
      }
    } else {
      next()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
})



// WEBPACK FOOTER //
// ./src/permission.js